/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sheet_Actions_TitleInputs */

const es_nav_sheet_actions_title = /** @type {(inputs: Nav_Sheet_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const gl_nav_sheet_actions_title = /** @type {(inputs: Nav_Sheet_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accións rápidas`)
};

const en_nav_sheet_actions_title = /** @type {(inputs: Nav_Sheet_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick actions`)
};

/**
* | output |
* | --- |
* | "Quick actions" |
*
* @param {Nav_Sheet_Actions_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_sheet_actions_title = /** @type {((inputs?: Nav_Sheet_Actions_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sheet_Actions_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_sheet_actions_title(inputs)
	if (locale === "en") return en_nav_sheet_actions_title(inputs)
	return es_nav_sheet_actions_title(inputs)
});